"use client";

import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { analytics } from "@/constants/common";

interface FaqLinkProps {
  href: string;
}

const StyledFaqLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  font-size: 16px;
  transition: color 0.2s ease;

  &&,
  &&:visited {
    color: #00998f;
  }

  &&:hover {
    color: #006d67;
    text-decoration: underline;
  }
`;

const FaqLink = React.forwardRef<HTMLAnchorElement, FaqLinkProps>(({ href }, ref) => {
  const { t } = useTranslation();

  return (
    <StyledFaqLink
      ref={ref}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => analytics.track("FAQ opened", { value: href })}
    >
      <QuestionCircleOutlined />
      {t("common.sidebar.faq")}
    </StyledFaqLink>
  );
});

FaqLink.displayName = "FaqLink";

export default FaqLink;
